import { render, staticRenderFns } from "./onlinePrinter.vue?vue&type=template&id=16516254&"
import script from "./onlinePrinter.vue?vue&type=script&lang=js&"
export * from "./onlinePrinter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports